import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { HomePage } from "@/components/HomePage";
import { Admin } from "@/components/Admin";
import { SchengenCountries } from "@/components/SchengenCountries";
import { UsVisa } from "@/components/UsVisa";
import { ArmeniaVisa } from "@/components/ArmeniaVisa";
import { Maintenance } from "@/components/Maintenance";

function App() {
  return (
    <BrowserRouter>
      <Toaster position="bottom-right" richColors />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/maintenance" element={<Maintenance />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/schengen-visa-countries" element={<SchengenCountries />} />
        <Route path="/us-tourist-visa" element={<UsVisa />} />
        <Route path="/armenia-visa" element={<ArmeniaVisa />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
